import styles from "../../styles/_sections/_shackClosing/table.module.scss";

const Table = () => {
  return (
    <div className={styles.container}>
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {/* delete */}
              <th></th>
              {/* start date */}
              <th>Start Date</th>
              {/* end date */}
              <th>End Date</th>
              {/* reason */}
              <th>Reason</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>delete</td>
              <td>21/12/2022</td>
              <td>31/12/2022</td>
              <td>Internal Issues</td>
            </tr>
            <tr>
              <td>delete</td>
              <td>21/12/2022</td>
              <td>31/12/2022</td>
              <td>Internal Issues</td>
            </tr>
            <tr>
              <td>delete</td>
              <td>21/12/2022</td>
              <td>31/12/2022</td>
              <td>Internal Issues</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
